/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ListSessionsPayload,
  ListSessionsPayload$Outbound,
  ListSessionsPayload$outboundSchema,
} from "../components/listsessionspayload.js";

export type ListSessionsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListSessionsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  listSessionsPayload: ListSessionsPayload;
};

/** @internal */
export type ListSessionsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListSessionsSecurity$outboundSchema: z.ZodMiniType<
  ListSessionsSecurity$Outbound,
  ListSessionsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSessionsSecurityToJSON(
  listSessionsSecurity: ListSessionsSecurity,
): string {
  return JSON.stringify(
    ListSessionsSecurity$outboundSchema.parse(listSessionsSecurity),
  );
}

/** @internal */
export type ListSessionsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  ListSessionsPayload: ListSessionsPayload$Outbound;
};

/** @internal */
export const ListSessionsRequest$outboundSchema: z.ZodMiniType<
  ListSessionsRequest$Outbound,
  ListSessionsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    listSessionsPayload: ListSessionsPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      listSessionsPayload: "ListSessionsPayload",
    });
  }),
);

export function listSessionsRequestToJSON(
  listSessionsRequest: ListSessionsRequest,
): string {
  return JSON.stringify(
    ListSessionsRequest$outboundSchema.parse(listSessionsRequest),
  );
}
